/**
 * TrendChart Component
 * Mini sparkline charts for showing trends
 * Used in DataCard and dashboard metrics
 */

import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import { colors } from '../../theme/designTokens';

/**
 * TrendChart Component
 *
 * @param {Array} data - Chart data (array of {value, timestamp})
 * @param {string} dataKey - Key for value (default: 'value')
 * @param {string} color - Line color (default: primary blue)
 * @param {number} height - Chart height in pixels (default: 40)
 * @param {boolean} showTooltip - Show tooltip on hover (default: true)
 * @param {Object} style - Additional styles
 */
function TrendChart({
  data = [],
  dataKey = 'value',
  color = colors.primary[500],
  height = 40,
  showTooltip = true,
  style = {},
}) {
  if (!data || data.length === 0) {
    return null;
  }

  // Custom tooltip formatter
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload[0]) return null;

    const value = payload[0].value;
    const timestamp = payload[0].payload.timestamp;

    return (
      <div
        style={{
          backgroundColor: '#fff',
          border: '1px solid #d9d9d9',
          borderRadius: 4,
          padding: '4px 8px',
          fontSize: 12,
        }}
      >
        <div style={{ fontWeight: 500 }}>{value}</div>
        {timestamp && (
          <div style={{ color: '#8c8c8c' }}>
            {new Date(timestamp).toLocaleDateString()}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ width: '100%', height, ...style }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          {showTooltip && <Tooltip content={<CustomTooltip />} />}
          <Line
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={2}
            dot={false}
            animationDuration={300}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TrendChart;
